export default __webpack_public_path__ + "static/media/rajab_2.33254abd.jpg";